import React, { useEffect, useState } from 'react'
import { Table, Button, Modal, Form, Input, InputNumber, Space, Popconfirm, message, Card, Tabs, Descriptions } from 'antd'
import { PlusOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons'
import api from '../api'
import useStore from '../store'

const PAIRS = [
  { key: 'RMB/VND', label: 'RMB / VND', desc: '1 RMB = ? VND' },
  { key: 'USD/VND', label: 'USD / VND', desc: '1 USD = ? VND' },
]

function RatePanel({ pair }) {
  const [data, setData] = useState([])
  const [baseRate, setBaseRate] = useState(null)
  const [open, setOpen] = useState(false)
  const [baseOpen, setBaseOpen] = useState(false)
  const [editing, setEditing] = useState(null)
  const [baseForm] = Form.useForm()
  const [form] = Form.useForm()
  const { user } = useStore()
  const canEdit = user?.role !== 'readonly'
  const pairInfo = PAIRS.find(p => p.key === pair)

  const load = () => {
    api.get('/exchange-rates').then(rows => setData(rows.filter(r => r.currency_pair === pair)))
    api.get(`/exchange-rates/base?currency_pair=${encodeURIComponent(pair)}`).then(r => setBaseRate(r.rate))
  }
  useEffect(() => { load() }, [pair])

  const saveBase = async () => {
    const values = await baseForm.validateFields()
    try {
      await api.post('/exchange-rates/base', { ...values, currency_pair: pair })
      message.success('基础汇率已保存')
      setBaseOpen(false)
      load()
    } catch (err) { message.error(err) }
  }

  const openModal = (record = null) => {
    setEditing(record)
    form.setFieldsValue(record ? { year_month: record.year_month, rate: parseFloat(record.rate) } : {})
    setOpen(true)
  }

  const onSave = async () => {
    const values = await form.validateFields()
    try {
      await api.post('/exchange-rates', { ...values, currency_pair: pair })
      message.success('月度汇率已保存')
      setOpen(false)
      form.resetFields()
      load()
    } catch (err) { message.error(err) }
  }

  const columns = [
    { title: '年月', dataIndex: 'year_month', width: 120 },
    { title: `汇率 (${pairInfo.desc})`, dataIndex: 'rate', render: v => parseFloat(v).toFixed(2) },
    { title: '更新时间', dataIndex: 'updated_at', render: v => new Date(v).toLocaleString() },
    canEdit && {
      title: '操作', width: 120, render: (_, r) => (
        <Space>
          <Button size="small" icon={<EditOutlined />} onClick={() => openModal(r)} />
          <Popconfirm title="确认删除？" onConfirm={async () => { await api.delete(`/exchange-rates/${r.id}`); load() }}>
            <Button size="small" danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </Space>
      )
    }
  ].filter(Boolean)

  return (
    <div>
      <Card
        title="基础汇率"
        style={{ marginBottom: 24 }}
        extra={canEdit && <Button type="primary" icon={<EditOutlined />} onClick={() => { baseForm.setFieldsValue({ rate: baseRate }); setBaseOpen(true) }}>修改</Button>}
      >
        <Descriptions>
          <Descriptions.Item label={pairInfo.desc}>
            {baseRate != null ? <strong>{parseFloat(baseRate).toFixed(2)}</strong> : <span style={{ color: '#999' }}>未设置</span>}
          </Descriptions.Item>
        </Descriptions>
        <div style={{ marginTop: 4, color: '#888', fontSize: 12 }}>当月未设置汇率时，收支录入自动使用此基础汇率</div>
      </Card>

      {canEdit && <Button type="primary" icon={<PlusOutlined />} onClick={() => openModal(null)} style={{ marginBottom: 16 }}>设置月度汇率</Button>}
      <Table dataSource={data} columns={columns} rowKey="id" />

      <Modal title="修改基础汇率" open={baseOpen} onOk={saveBase} onCancel={() => setBaseOpen(false)}>
        <Form form={baseForm} layout="vertical">
          <Form.Item name="rate" label={pairInfo.desc} rules={[{ required: true }]}>
            <InputNumber style={{ width: '100%' }} min={0} step={1} precision={2} />
          </Form.Item>
        </Form>
      </Modal>

      <Modal title={editing ? '编辑月度汇率' : '设置月度汇率'} open={open} onOk={onSave} onCancel={() => { setOpen(false); setEditing(null) }}>
        <Form form={form} layout="vertical">
          <Form.Item name="year_month" label="年月 (YYYY-MM)" rules={[{ required: true }]}>
            <Input placeholder="2024-01" disabled={!!editing} />
          </Form.Item>
          <Form.Item name="rate" label={pairInfo.desc} rules={[{ required: true }]}>
            <InputNumber style={{ width: '100%' }} min={0} step={1} precision={2} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  )
}

export default function ExchangeRatesPage() {
  return (
    <Tabs items={PAIRS.map(p => ({ key: p.key, label: p.label, children: <RatePanel pair={p.key} /> }))} />
  )
}
